import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["palette-item", { selected: _ctx.selected }]),
    style: _normalizeStyle({ backgroundColor: _ctx.color }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedColor(_ctx.color)))
  }, [
    (_ctx.selected)
      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
          key: 0,
          class: "check-icon",
          icon: ['fas', 'check'],
          style: _normalizeStyle({ color: _ctx.checkIconColor })
        }, null, 8, ["style"]))
      : _createCommentVNode("", true)
  ], 6))
}